var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"modal"}},[_c('div',{staticClass:"modal-mask"},[_c('div',{staticClass:"modal-wrapper",on:{"click":_vm.close}},[_c('div',{staticClass:"modal-container"},[_vm._t("default")],2)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }